import { render, staticRenderFns } from "./followClientView.vue?vue&type=template&id=63322ddb&"
import script from "./followClientView.vue?vue&type=script&lang=js&"
export * from "./followClientView.vue?vue&type=script&lang=js&"
import style0 from "./followClientView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports